// extracted by mini-css-extract-plugin
module.exports = {"replica-page":"replica_replica-page__3BAlS"};